function openPopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').removeClass("hu_none");
                jQuery('.window-cover').show();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
    }
      function closePopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').addClass("hu_none");
        jQuery('.window-cover').hide();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').addClass("hu_none");
        jQuery('.window-cover').hide();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').addClass("hu_none");
        jQuery('.window-cover').hide();
        }
    }

// 跳到顶部   
jQuery(function(){
    var height=jQuery(window).height();
	jQuery(window).scroll(function(){
		if (jQuery(window).scrollTop()>height){
			jQuery(".look_up-hu").show();
		}else{
			jQuery(".look_up-hu").hide();
			}
	})
    jQuery('.look_up-hu').on('click', function () {
        try{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }catch(e){
            window.scrollTo(0,0);
        }
    });
})
/* 固定详情页加购按钮 */
if ($('body').hasClass('template-product')) {
  if($(document).width()<750){
    let but_top = $('.wap-button').offset().top
    $(window).scroll(function(event){
      let doc_scrollTop = $(document).scrollTop();
      if(Number(but_top)<Number(doc_scrollTop)+Number(50)){
        $('.wap-button').css({"position":"fixed","bottom":"0","z-index":"2","width":"91%","display":"flex"});
        $('.add-to-cart.btn--secondary').css({"width":"50%","border-color":"#f46809","color":"#f46809","background":"#fff"});
        $('.payment-buttons .shopify-payment-button').css({"width":"50%","margin-top":"0px","border-color":"#f46809","color":"#f46809"});
        $('.shopify-payment-button .shopify-payment-button__button').css({"background":"#000"});
      }else{
        $('.wap-button').css({"position":"relative","bottom":"0","z-index":"2","width":"auto","display":"block"});
        $('.add-to-cart.btn--secondary').css({"width":"100%","border-color":"#f46809","color":"#f46809","background":"#fff"});
        $('.payment-buttons .shopify-payment-button').css({"width":"100%","margin-top":"10px","border-color":"#f46809","color":"#f46809"});
        $('.shopify-payment-button .shopify-payment-button__button').css({"background":"#000"});
      }
    });
  }
}

jQuery(function(){
  var advanced = new Swiper('.hu-lunbo', {
            slidesPerView:3,
             allowSlideNext: false,
             allowSlidePrev: false,
              breakpoints: { 
      		 768: {
                allowSlideNext: true,
                allowSlidePrev: true,
      			slidesPerView:2.3,
      			spaceBetween: 5,
      			},
        	}
        });
})

// 新版倒计时
    function getLocalTime(i) {
        if (typeof i !== 'number') return;
        var d = new Date();
        var len = d.getTime();
        var offset = d.getTimezoneOffset() * 60000;
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }

    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        console.log(dd)
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }
    var timeZoneParams = -7;
    jQuery(function() {
        if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;

            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0;
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor(intDiff / 1000 / 60 % 60);
                    second = Math.floor(intDiff / 1000 % 60);
                }
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }

                jQuery('.flashSale-clock_timeH').text(hour);
                jQuery('.flashSale-clock_timeM').text(minute);
                jQuery('.flashSale-clock_timeS').text(second);
                // 时
                var str1 = hour + '';
                var s1 = str1.substr(0, 1);
                jQuery('.memberFlash-time_timeH_one').text(s1);
                jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
                // 分
                var str2=minute + '';
                var s2=str2.substr(0, 1);
                jQuery('.memberFlash-time_timeM_one').text(s2);
                jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
                // 秒
                var str3=second + '';
                var s3=str3.substr(0, 1);
                jQuery('.memberFlash-time_timeS_one').text(s3);
                jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
            }
            var groupTime = setInterval(function() {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth();
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                    endAllTime = new Date(endTime).getTime() - date;
                }
            }, 1000);
        }

    })
    // 倒计时结束


/* shouye daojishi js */
window.timeZoneParams = -16;
    /* getLocalTime:时区换算*/
    window.getLocalTime = function (i) {
        // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        var d = new Date();
        //得到1970年一月一日到现在的秒数
        var len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        var offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }
    /*end getLocalTime:时区换算*/
    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }


    $(function () {
        if ($(".memberFlash-timeBox").length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + "/" + date_month + "/" + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;
            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; //鏃堕棿榛樿鍊�
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
                if (!$(".hl .item").eq(hourInt).hasClass("active")) {
                    $(".hl .item.before").removeClass("before");
                    $(".hl .item").eq(int1).addClass("before");
                    $(".hl .item.active").removeClass("active");
                    $(".hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".hr .item").eq(hourDot).hasClass("active")) {
                    $(".hr .item.before").removeClass("before");
                    $(".hr .item").eq(int2).addClass("before");
                    $(".hr .item.active").removeClass("active");
                    $(".hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".ml .item").eq(minuteInt).hasClass("active")) {
                    $(".ml .item.active").removeClass("active");
                    $(".ml .item").eq(minuteInt).addClass("active");
                    $(".ml .item.before").removeClass("before");
                    $(".ml .item").eq(int3).addClass("before");
                }

                if (!$(".mr .item").eq(minuteDot).hasClass("active")) {
                    $(".mr .item.active").removeClass("active");
                    $(".mr .item").eq(minuteDot).addClass("active");
                    $(".mr .item.before").removeClass("before");
                    $(".mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".sl .item").eq(secondInt).hasClass("active")) {
                    $(".sl .item.active").removeClass("active");
                    $(".sl .item").eq(secondInt).addClass("active");
                    $(".sl .item.before").removeClass("before");
                    $(".sl .item").eq(int5).addClass("before");
                }

                if (!$(".sr .item").eq(secondDot).hasClass("active")) {
                    $(".sr .item.active").removeClass("active");
                    $(".sr .item").eq(secondDot).addClass("active");
                    $(".sr .item.before").removeClass("before");
                    $(".sr .item").eq(int6).addClass("before");
                }
            }
            var groupTime = setInterval(function () {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth() + 1;
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + "/" + date_month + "/" + date_day,1);
                    endAllTime = new Date(endTime).getTime() - date;
                    if (typeof every_flash_enable != "undefined" && every_flash_enable == '1') {
                        homeFlash();
                    }
                }
            }, 1000);
        }
    })


function copyCodeClipboard(e) {
    var i = document.createElement("textarea");
    i.value = e, i.setAttribute("readonly", ""), i.style.position = "absolute", i.style.left = "-9999px", document.body.appendChild(i);
    var t = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : !1;
    i.select(), document.execCommand("copy"), document.body.removeChild(i), t && (document.getSelection().removeAllRanges(), document.getSelection().addRange(t))
}

function copyCoupons(e) {
    var i = e.target;
    copyCodeClipboard(i.getAttribute("data-code"));
    alert("Copy successfully！"); // 添加弹窗提示
}

// 博客右侧边栏固定

$(document).ready(function() {
  // 监听滚动事件
  $(window).scroll(function() {
  // 获取滚动位置
    var scrollTop = $(window).scrollTop();
  // 滚动超过100px时固定侧边栏
    if (scrollTop > 100) {
      $('.do_none').addClass('fixed');
    } else {
      $('.do_none').removeClass('fixed');
    }
  });
  // 响应式设计 - 在小屏幕上禁用固定效果
  function handleResponsive() {
    if ($(window).width() < 992) {
      $('.do_none').removeClass('fixed');
    }
  }

    // 初始检查和窗口大小变化监听
    handleResponsive();
    $(window).resize(handleResponsive);
});


// 首页新轮播 sections\featured-collection-swiper.liquid
var mySwiper4 = new Swiper('.hu-featured-swiper', {
    slidesPerView: 5,
    spaceBetween : 0,
    navigation: { 
        nextEl: '.hu-flash-swiper .swiper-button-next', 
        prevEl: '.hu-flash-swiper .swiper-button-prev', 
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween : 0,
        allowSlideNext: false,
        allowSlidePrev: false,
      }
    },
    // scrollbar: {
    //   el: ".hu-featured-swiper .swiper-scrollbar",
    //   draggable: true,
    //   hide: false
    // }
});

// 首页flash sections\featured-collection-newflash.liquid
var mySwiper5 = new Swiper('.hu-new-flash', {
    slidesPerView: 4.8,
    spaceBetween : 0,
    navigation: { 
        nextEl: '.newflash-pro .swiper-button-next', 
        prevEl: '.newflash-pro .swiper-button-prev', 
    },

    breakpoints: {
      768: {
        slidesPerView: 2.1,
        spaceBetween : 0,
      }
    },
    // scrollbar: {
    //   el: ".hu-new-flash .swiper-scrollbar",
    //   draggable: true,
    //   hide: false
    // }
});
// 首页sections\hu-trustpilot-reviews.liquid
$('.hu-trustpilot-swiper').each(function () {
    new Swiper(this, {
        slidesPerView: 3.3,
        spaceBetween: 20,
        navigation: {
            nextEl: $(this).find('.swiper-button-next')[0],
            prevEl: $(this).find('.swiper-button-prev')[0]
        },
        breakpoints: {
            768: {
                slidesPerView: 1.3,
                spaceBetween: 8
            }
        }
    });
});








